import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { subscribeToTimer } from '../services/vpsApi';
import TimerControls from '../components/TimerControls';
import './ControlPanel.css';

function ControlPanel() {
  const { timerId } = useParams();
  const [timer, setTimer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeToTimer(timerId, (timerData) => {
      setTimer(timerData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [timerId]);

  if (loading) {
    return (
      <div className="control-panel-loading">
        <div className="loading-spinner"></div>
        <p>載入控制面板中...</p>
      </div>
    );
  }

  if (!timer) {
    return (
      <div className="control-panel-error">
        <h2>錯誤</h2>
        <p>找不到計時器</p>
      </div>
    );
  }

  return (
    <div className="control-panel-page">
      <TimerControls timer={timer} standalone={true} />
    </div>
  );
}

export default ControlPanel;
